export default __webpack_public_path__ + "static/media/PPI-steps-008.16128f74.jpg";